import { ValueView } from "web/components"

import { RecordContext } from "web/contexts"
import { isNotAValue, isObjectWithProperty } from "web/services/helpers"
import classNames from "classnames"

function FieldView({ field, hasFieldAction, fieldAction, displayValue }) {
  return (
    <tr key={field.key} className={"h-[30px]"}>
      <td className="w-2/5 truncate pr-2.5 align-middle text-xs text-neutral-4">
        {field.label}
      </td>
      <td
        className={classNames("w-3/5 truncate pr-2.5 align-middle", {
          "cursor-pointer text-primary-4 hover:text-feature-6": hasFieldAction,
        })}
        onClick={fieldAction}
      >
        <ValueView fieldKey={field.key} {...displayValue} />
      </td>
    </tr>
  )
}

export default function RecordView({
  data,
  fields,
  fieldActions = {},
  fieldLimit,
}) {
  if (data === undefined) return null
  return (
    <RecordContext.Provider value={data}>
      <table className="w-full table-fixed text-left">
        <tbody>
          {fields
            .filter((field) => !isNotAValue(data.values[field.key]))
            .map((field, i) => {
              if (fieldLimit && i >= fieldLimit) return null

              const hasFieldAction = field.name in fieldActions

              const fieldAction = hasFieldAction
                ? () => fieldActions[field.name](data)
                : () => {}

              const displayValue = isObjectWithProperty(
                data.values[field.key],
                "value"
              )
                ? data.values[field.key]
                : { value: data.values[field.key] }

              return (
                <FieldView
                  key={field.key}
                  field={field}
                  hasFieldAction={hasFieldAction}
                  fieldAction={fieldAction}
                  displayValue={displayValue}
                />
              )
            })}
        </tbody>
      </table>
    </RecordContext.Provider>
  )
}
